export enum AccumulationPointClassType {
    BUY_COMPLETE,
    REGISTER_USER,
    EVENT,
    WRITE_REVIEW,
    WRITE_PREMIUM_REVIEW,
    AFTER_USE_WRITE_REVIEW,
    AFTER_USE_WRITE_PREMIUM_REVIEW,
    NSP_BUY,
    CHARGE_ADD_ACM,
    BANKBOOK_ACM,
    BUY_COMPLETE_ADD_ACM,
    ARRIVAL_GUARANTEE_ADD_ACM,
    MEMBERSHIP_ARRIVAL_GUARANTEE_ADD_ACM,
    PRE_ACM,
    DIGITAL_CONTENTS_ACM,
}

/** 본인인증 미확인 유저의 최대 충전(혹은 보유)가능 금액
 * https://oss.fin.navercorp.com/billing-np/AutoPayment_issue/issues/1#issuecomment-368843 */
export const MAXIMUM_LIMIT_CHARGE_POINT_FOR_RESTRICTED_USER = 500000

/** 충전포인트 취급정책 */
export const ChargePointPolicy = {
    /**
     * 기본 정책
     * - 페이머니 회원상태에 따라 충전포인트 또는 페이머니로 취급
     */
    DEFAULT: 'DEFAULT',
    /** 항상 페이머니로 취급 */
    PAYMONEY: 'PAYMONEY',
} as const

export type ChargePointPolicyType = Constant<typeof ChargePointPolicy>
